<template>
    <div>
        <section id="content" class="no-padding">
            <!-- >>> Start:Upper Banner -->
            <div class="banner imagebg-container" style="height: 350px; background-image: url(/res/images/career/careers-banner.jpg);">
                <div class="container">
                    <h1 class="big-caption">{{ bannerline1[getCurrentLocale] }} <em>{{ now[getCurrentLocale] }}</em></h1>
                    <h2 class="med-caption yellow-color">{{ bannerline2[getCurrentLocale] }} <strong>SUNDAIR</strong>.</h2>
                </div>
            </div>
            <!-- <<< End:Upper Banner -->

            <!-- >>> Start:Tabs -->
            <div class="tab-wrapper">
                <div class="tab-container container trans-style">
                    <ul class="tabs no-padding">
                        <li><a data-toggle="tab" href="#general"><i class="soap-icon-friends"></i>{{ tabtitle1[getCurrentLocale] }}</a></li>
                        <li><a data-toggle="tab" href="#stralsund"><i class="soap-icon-friends"></i>{{ tabtitle2[getCurrentLocale] }}</a></li>
                        <li class="active"><a data-toggle="tab" href="#berlin"><i class="soap-icon-friends"></i>{{ tabtitle3[getCurrentLocale] }}</a></li>
                    </ul>

                    <div class="tab-content">
                        <div id="general" class="tab-pane fade">
                            <div class="md-section">
                                <!-- Begin:PagePressReleases -->
                                <div id="main" class="col-sm-8 col-md-9">
                                    <h2 class="skin-color">{{ openpositions[getCurrentLocale] }}: {{ tabtitle1[getCurrentLocale] }}</h2><br />

                                    <!-- Dienstwagenführer / Fahrer (m/w/d) -->
                                    <!-- <div class="toggle-container question-list">
                                        <div class="panel style1">
                                            <h4 class="panel-title">
                                                <a data-toggle="collapse" href="#tgg1212">Dienstwagenführer/Fahrer (Kassel) - Minijob (m/w/d)</a>
                                            </h4>
                                            <div id="tgg1212" class="panel-collapse collapse">
                                                <div class="panel-content">
                                                    <p><h3>AUFGABEN:</h3><p />
                                                    <ul class="check-circle box">
                                                        <li>Chauffeurdienste für die Geschäftsleitung</li>
                                                        <li>Flughafentransfers</li>
                                                        <li>Erledigung von Botenfahrten</li>
                                                        <li>Wartung, Pflege und Reinigung von zugeordneten Fahrzeugen im Pool</li>
                                                        <li>Übernahme von Sonderaufgaben</li>
                                                    </ul>


                                                 <p><h3>IHR PROFIL:</h3><p />
                                                    <ul class="check-circle box">
                                                        <li>Gültiger Führerschein Klasse B</li>
                                                        <li>umfangreiche Fahrpraxis, Fahrzeugkenntnisse</li>
                                                        <li>Fließendes Deutsch und Englisch in Wort und Schrift</li>
                                                        <li>Schnelle Auffassungsgabe</li>
                                                        <li>Stressresistenz, Organisationstalent, Zuverlässigkeit, Flexibilität und Sorgfalt</li>
                                                    </ul>
                                                    <p>Sie erwartet ein herausfordernder Arbeitsplatz mit interessanten Möglichkeiten der persönlichen Weiterentwicklung. Sind Sie interessiert?</p>
                                                    <p>Dann senden Sie bitte Ihre aussagekräftige, vollständige Bewerbung im PDF-Format unter Angabe des frühesten Eintrittstermins per E-Mail an:</p>
                                                    <p><h2>KARRIERE@SUNDAIR.COM</h2></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div> -->
                                </div>
                                <!-- End:PagePressReleases -->



                                <!-- Begin:Content-SideBar-Booking -->
                                <div class="sidebar col-sm-4 col-md-3">
                                    <sdr-aboutsundair-box></sdr-aboutsundair-box>
                                    <sdr-contact-box></sdr-contact-box>
                                </div>
                                <!-- End:Content-SideBar-Booking -->
                            </div>
                        </div>


                        <div id="stralsund" class="tab-pane fade">
                            <div class="md-section">
                                <!-- Begin:PagePressReleases -->
                                <div id="main" class="col-sm-8 col-md-9">
                                    <h2 class="skin-color">{{ openpositions[getCurrentLocale] }}: {{ tabtitle2[getCurrentLocale] }}</h2><br />

                                    <!-- Steuerreferent (m/w/d) -->
                                    <div class="toggle-container question-list">
                                        <div class="panel style1">
                                            <h4 class="panel-title">
                                                <a data-toggle="collapse" href="#tgg2345qq">Steuerreferent (m/w/d)</a>
                                            </h4>
                                            <div id="tgg2345qq" class="panel-collapse collapse">
                                                <div class="panel-content">
                                                    <p><h3>AUFGABEN:</h3></p>
                                                    <ul class="check-circle box">
                                                        <li>Verantwortlich für die Sicherstellung der sach- und termingerechten Erstellung der Monats- und Jahresabschlüsse nach HGB sowie Statistiken</li>
                                                        <li>Erarbeitung, Implementierung und Weiterentwicklung neuer Standards und Strukturen</li>
                                                        <li>Aufbereitung von finanziellen Daten für die Geschäftsleitung (Reporting)</li>
                                                        <li>Identifikation von Entwicklungsmöglichkeiten, Kostenreduzierungen und Systemverbesserungen</li>
                                                        <li>Steuerliche Beratung von Kapital- und Personengesellschaften im Inland</li>
                                                        <li>Erstellung von Steuererklärungen</li>
                                                        <li>Verantwortung für die Einhaltung der Tax Compliance</li>
                                                        <li>Vorbereitung und Mitwirkung bei Prüfungen durch Dritte</li>
                                                        <li>Mitwirkung bei steuerlichen Sonderprojekten</li>
                                                        <li>Ermittlung von Strategien zur optimalen Kapitalnutzung</li>

                                                    </ul>


                                                    <p><h3>IHR PROFIL:</h3></p>
                                                    <ul class="check-circle box">
                                                        <li>Erfolgreich abgeschlossenes Studium der Wirtschaftswissenschaften, Steuerberaterexamen oder kaufmännische Ausbildung mit entsprechender Weiterbildung</li>
                                                        <li>Kenntnisse im Bereich der Luftfahrt und einschlägige Berufserfahrung wären von Vorteil</li>
                                                        <li>sichere Rechnungslegungskenntnisse nach HGB</li>
                                                        <li>Erfahren in der Analyse und Optimierung von Geschäftsprozessen,Strukturen und Organisationen</li>
                                                        <li>Unternehmerische und analytische Denkweise</li>
                                                        <li>Selbstständige, ziel- und ergebnisorientierte Arbeitsweise</li>

                                                        <li>Eine ausgesprochene Hands-on-Mentalität sowie eine hohe Ziel- und Umsetzungsorientierung</li>
                                                        <li>Verbindliche und zuverlässige Kommunikation gegenüber Geschäftspartnern und Mitarbeitern</li>
                                                        <li>Kommunikationssichere Englischkenntnisse </li>
                                                    </ul>

                                                    <p>Sie erwartet ein herausfordernder Arbeitsplatz mit interessanten Möglichkeiten der persönlichen Weiterentwicklung. Sind Sie interessiert?</p>
                                                    <p>Dann senden Sie bitte Ihre aussagekräftige, vollständige Bewerbung im PDF-Format unter Angabe Ihrer Gehaltsvorstellungen und des frühesten Eintrittstermins per E-Mail an:</p>
                                                    <p><h2>KARRIERE@SUNDAIR.COM</h2></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div><br />

                                    <!-- Buchhalter (m/w/d) -->
                                    <!-- <div class="toggle-container question-list">
                                        <div class="panel style1">
                                            <h4 class="panel-title">
                                                <a data-toggle="collapse" href="#tgg2345aaa">Buchhalter (m/w/d)</a>
                                            </h4>
                                            <div id="tgg2345aaa" class="panel-collapse collapse">
                                                <div class="panel-content">
                                                    <p><h3>AUFGABEN:</h3></p>
                                                    <ul class="check-circle box">
                                                        <li>Selbständige und eigenverantwortliche Bearbeitung der Finanzbuchhaltung hierzu gehören u.a.: Prüfung und Verbuchung laufender Geschäftsvorfälle nach gesetzlichen und steuerlichen Vorgaben, Kassen- und Bankbuchung, Lohnbuchhaltung</li>
                                                        <li>Kontinuierliche Kontenpflege, -abstimmung und -klärung sowie Stammdatenpflege</li>
                                                        <li>Offene-Posten-Bearbeitung (Debitoren / Kreditoren)</li>
                                                        <li>Abwicklung des laufenden in- und ausländischen Zahlungsverkehrs</li>
                                                        <li>Verwaltung und Verbuchung der Kreditkartenabrechnungen</li>
                                                        <li>Mitwirkung bei der Erstellung der Monats- und Jahresabschlüsse nach HGB</li>
                                                        <li>Sonstige im betrieblichen Rechnungswesen anfallende Tätigkeiten</li>
                                                    </ul>

                                                    <p><h3>IHR PROFIL:</h3></p>
                                                    <ul class="check-circle box">
                                                        <li>Abgeschlossene kaufmännische Berufsausbildung mit Schwerpunkt Buchhaltung gerne mit Weiterbildung zum Finanzbuchhalter oder Steuerfachwirt</li>
                                                        <li>Fundierte Buchhaltungskenntnisse und möglichst Berufserfahrung in einer vergleichbaren Position</li>
                                                        <li>Gute MS-Office Kenntnisse, insbesondere in Excel</li>
                                                        <li>Gutes Kommunikationsvermögen und Englischkenntnisse in Wort und Schrift</li>
                                                        <li>Teamfähigkeit, Verantwortungsbewusstsein, gewissenhafte und zuverlässige Arbeitsweise</li>
                                                        <li>Dein Profil wird durch Neugier, Einsatzbereitschaft, analytische Fähigkeit sowie Affinität zu Zahlen abgerundet</li>
                                                    </ul>

                                                    <p>Sie erwartet ein herausfordernder Arbeitsplatz mit interessanten Möglichkeiten der persönlichen Weiterentwicklung. Sind Sie interessiert?</p>
                                                    <p>Dann senden Sie bitte Ihre aussagekräftige, vollständige Bewerbung im PDF-Format unter Angabe Ihrer Gehaltsvorstellungen und des frühesten Eintrittstermins per E-Mail an:</p>
                                                    <p><h2>KARRIERE@SUNDAIR.COM</h2></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div><br /> -->
                                </div>
                                <!-- End:PagePressReleases -->



                                <!-- Begin:Content-SideBar-Booking -->
                                <div class="sidebar col-sm-4 col-md-3">
                                    <sdr-aboutsundair-box></sdr-aboutsundair-box>
                                    <sdr-contact-box></sdr-contact-box>
                                </div>
                                <!-- End:Content-SideBar-Booking -->
                            </div>
                        </div>


                        <div id="berlin" class="tab-pane fade in active">
                            <div class="md-section">
                                <!-- Begin:PagePressReleases -->
                                <div id="main" class="col-sm-8 col-md-9">
                                    <h2 class="skin-color">{{ openpositions[getCurrentLocale] }}: {{ tabtitle3[getCurrentLocale] }}</h2><br />

                                    <!-- Quality Manager (m/w/d) -->
                                    <div class="toggle-container question-list">
                                        <div class="panel style1">
                                            <h4 class="panel-title">
                                                <a data-toggle="collapse" href="#tgg2xxxyxz213zzzxxyyyy">Quality Manager (m/w/d)</a>
                                            </h4>
                                            <div id="tgg2xxxyxz213zzzxxyyyy" class="panel-collapse collapse">
                                                <div class="panel-content">
                                                    <p><h3>AUFGABEN:</h3></p>
                                                    <ul class="check-circle box">
                                                        <li>Zusammenarbeit	mit	der	Aufsichtsbehörde</li>
                                                        <li>die	Mitarbeiterführung	im	Fachbereich</li>
                                                        <li>Sicherstellung	der	Durchführung	von	Präventions- und	Korrekturmaßnahmen</li>
                                                        <li>Aufstellung,	Dokumentation,	Entwicklung	des	Fachbereichs	Quality	Management	in	Übereinstimmung	mit	den	behördlichen	Regularien</li>
                                                        <li>Organisation	und	Führung	von	fachbereichsbezogenen	Projektplänen	und	-dokumentationen</li>
                                                        <li>Aufrechterhaltung	der	Qualitätspolitik	und	des	Qualitätssystems</li>
                                                        <li>Überprüfung	des	Qualitätssystems	neuer	Dienstleister</li>
                                                        <li>die	Verantwortliche	Entwicklung,	Organisation	und	Führung	von	fachbereichsbezogenen	Projektplänen	und	-dokumentationen</li>
                                                        <li>Sicherstellung	der	Qualifikation	von	Mitarbeitern,	die	Qualitätsinspektionen	oder	Audits	durchführen</li>
                                                        <li>Überwachung	der	Gültigkeiten	aller	relevanten	Dokumente</li>
                                                        <li>Veröffentlichung	von	Änderungen	qualitätsrelevanter Sachverhalte</li>
                                                        <li>Teilnahme	und	Mitarbeit	im	Planungs- und	Leitungsteam	des	Unternehmens</li>
                                                        <li>die	Schnittstellenfunktion	der	Geschäftsführung	für	Mitarbeiter/innen	sowie	für	externe	Gesprächspartner</li>
                                                    </ul>

                                                    <p><h3>IHR PROFIL:</h3></p>
                                                    <ul class="check-circle box">
                                                        <li>abgeschlossene	Berufsausbildung	und	Fortbildung	im	kaufmännischen	Bereich, Hochschulstudium	im	Bereich	Compliance, Qualitätsmanagement, Recht	in	der	Luftfahrt	oder	einer	vergleichbaren	Richtung von	Vorteil</li>
                                                        <li>5	Jahre	Berufserfahrung	in	der	Luftfahrt,	vorzugsweise	bei	einer	Fluggesellschaft</li>
                                                        <li>2	Jahre	einschlägige Berufs- und	Managementerfahrung	in einer	vergleichbaren	Position</li>
                                                        <li>umfassende	Kenntnisse	über	einschlägige	Betriebs- und	Instandhaltungsvorschriften	der	Europäischen	Union	und	die	damit verbundenen	Vorschriften,	Anforderungen	und	Verfahren,	sowie	die	Betriebsdokumentation	des	Luftfahrtunternehmens/Unternehmens</li>
                                                        <li>hohes	Maß	an	Verantwortungs- und	Pflichtbewusstsein</li>
                                                        <li>hohe	Belastbarkeit	in	Stresssituationen</li>
                                                        <li>Durchsetzungsvermögen</li>
                                                        <li>Organisations- und	Improvisationstalent	sowie	hohe	Flexibilität</li>
                                                        <li>Sehr	gute	Deutsch- und	Englischkenntnisse	in	Wort	und	Schrift</li>
                                                        <li>sehr	gute	MS-Office	Kenntnisse</li>
                                                    </ul>

                                                    <p>Sie erwartet ein herausfordernder Arbeitsplatz mit interessanten Möglichkeiten der persönlichen Weiterentwicklung. Sind Sie interessiert?</p>
                                                    <p>Dann senden Sie bitte Ihre aussagekräftige Bewerbung im PDF-Format unter Angabe Ihrer Gehaltsvorstellungen und des frühesten Eintrittstermins per E-Mail an:</p>
                                                    <p><h2>KARRIERE@SUNDAIR.COM</h2></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div><br />

                                    <!-- Deputy Quality Manager (m/w/d) -->
                                    <!-- <div class="toggle-container question-list">
                                        <div class="panel style1">
                                            <h4 class="panel-title">
                                                <a data-toggle="collapse" href="#tgg2xxxyxz213zzzxxyyyyy">Deputy Quality Manager (m/w/d)</a>
                                            </h4>
                                            <div id="tgg2xxxyxz213zzzxxyyyyy" class="panel-collapse collapse">
                                                <div class="panel-content">
                                                    <p><h3>AUFGABEN:</h3></p>
                                                    <ul class="check-circle box">
                                                        <li>Zusammenarbeit	mit	der	Aufsichtsbehörde</li>
                                                        <li>Sicherstellung	der	Durchführung	von	Präventions- und	Korrekturmaßnahmen</li>
                                                        <li>Unterstützung	in	der	Entwicklung	und	Dokumentation des	Fachbereichs	Quality	Management	in	Übereinstimmung	mit	den	behördlichen	Regularien</li>
                                                        <li>Mitarbeit	in	der	Organisation	und	Führung	von	fachbereichsbezogenen	Projektplänen	und	-dokumentationen</li>
                                                        <li>Aufrechterhaltung	der	Qualitätspolitik	und	des	Qualitätssystems</li>
                                                        <li>die	Verantwortliche	Entwicklung,	Organisation	und	Führung	von	fachbereichsbezogenen	Projektplänen	und	-dokumentationen</li>
                                                        <li>Sicherstellung	und	Durchführung, Unterstützung in	der	Planung	von	Qualitätsinspektionen	und Audits</li>
                                                        <li>Überwachung	der	Gültigkeiten	aller	relevanten	Dokumente</li>
                                                        <li>Veröffentlichung	von	Änderungen	qualitätsrelevanter Sachverhalte</li>
                                                        <li>Teilnahme	und	Mitarbeit	im	Planungs- und	Leitungsteam	des	Unternehmens im	Vertretungsfall</li>
                                                    </ul>

                                                    <p><h3>IHR PROFIL:</h3></p>
                                                    <ul class="check-circle box">
                                                        <li>abgeschlossene	Berufsausbildung,	Hochschulstudium	von	Vorteil</li>
                                                        <li>5 Jahre	Berufserfahrung	in	der	Luftfahrt,	vorzugsweise	bei	einer	Fluggesellschaft</li>
                                                        <li>2	Jahre	einschlägige	Berufs- und	Managementerfahrung	in	einer	vergleichbaren	Position</li>
                                                        <li>Kenntnisse	über einschlägige	Betriebs- und	Instandhaltungsvorschriften	der	Europäischen	Union	für	Luftfahrtunternehmen	von	Vorteil</li>
                                                        <li>hohes	Maß	an	Verantwortungs- und	Pflichtbewusstsein</li>
                                                        <li>hohe	Belastbarkeit	in	Stresssituationen</li>
                                                        <li>Durchsetzungsvermögen</li>
                                                        <li>Organisations- und	Improvisationstalent	sowie	hohe	Flexibilität</li>
                                                        <li>Interesse	an	Dokumentationsarbeit	und	Qualität</li>
                                                        <li>Sehr	gute	Deutsch- und	Englischkenntnisse	in	Wort	und	Schrift</li>
                                                        <li>sehr	gute	MS-Office	Kenntnisse</li>
                                                    </ul>

                                                    <p>Sie erwartet ein herausfordernder Arbeitsplatz mit interessanten Möglichkeiten der persönlichen Weiterentwicklung. Sind Sie interessiert?</p>
                                                    <p>Dann senden Sie bitte Ihre aussagekräftige Bewerbung im PDF-Format unter Angabe Ihrer Gehaltsvorstellungen und des frühesten Eintrittstermins per E-Mail an:</p>
                                                    <p><h2>KARRIERE@SUNDAIR.COM</h2></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div><br /> -->

                                    <!-- Mitarbeiter Kundenservice (m/w/d) -->
                                    <!-- <div class="toggle-container question-list">
                                        <div class="panel style1">
                                            <h4 class="panel-title">
                                                <a data-toggle="collapse" href="#tgg2xxxyxz213zzzxxyy">Mitarbeiter Kundenservice (m/w/d)</a>
                                            </h4>
                                            <div id="tgg2xxxyxz213zzzxxyy" class="panel-collapse collapse">
                                                <div class="panel-content">
                                                    <p><h3>AUFGABEN:</h3></p>
                                                    <ul class="check-circle box">
                                                        <li>Schriftliche	und	telefonische	Information	und	Beratung	von	Fluggästen	und	Reisebüros</li>
                                                        <li>Buchung	und	Bearbeitung	von	Sitzplatzreservierungen	und	Sondergepäckanmeldungen</li>
                                                        <li>Kommunikation	von	Flugzeitenänderungen</li>
                                                        <li>Bearbeitung	von	Passagier-Namenslisten	und	Passagier-Servicelisten</li>
                                                        <li>Bearbeitung	von	Gepäck-Reklamationen</li>
                                                        <li>Schriftliche	und	telefonische	Bearbeitung	von	Beschwerden,	Lob	und	Anregungen	unserer	Fluggäste	</li>
                                                    </ul>

                                                    <p><h3>IHR PROFIL:</h3></p>
                                                    <ul class="check-circle box">
                                                        <li>Erfolgreich	abgeschlossene	Ausbildung	im	Luftverkehr	oder	der	Reisebranche</li>
                                                        <li>Relevante	Berufserfahrung	im	Touristikmarkt</li>
                                                        <li>Sehr	gute	MS	Office-Kenntnisse</li>
                                                        <li>Sehr	gute	Deutsch- und	Englischkenntnisse;	weitere	Sprachkenntnisse	sind	von	Vorteil</li>
                                                        <li>Professionelle	Kundenorientierung	und	Freude	am	Kundenkontakt</li>
                                                        <li>Sehr	gutes	schriftliches	und	mündliches	Ausdrucksvermögen</li>
                                                        <li>Fähigkeit	zur	Gesprächsführung	auch	in	schwierigen	Situationen</li>
                                                        <li>Hohe	Einsatzbereitschaft,	Belastbarkeit	und	Teamfähigkeit</li>
                                                        <li>Flexibilität	sowie	Bereitschaft	zum	Schichtdienst	(auch	am	Wochenende	und	an	Feiertagen)</li>
                                                    </ul>

                                                    <p>Sie erwartet ein herausfordernder Arbeitsplatz mit interessanten Möglichkeiten der persönlichen Weiterentwicklung. Sind Sie interessiert?</p>
                                                    <p>Dann senden Sie bitte Ihre aussagekräftige Bewerbung im PDF-Format unter Angabe Ihrer Gehaltsvorstellungen und des frühesten Eintrittstermins per E-Mail an:</p>
                                                    <p><h2>KARRIERE@SUNDAIR.COM</h2></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div><br /> -->

                                    <!-- Assistenz Director Ground Operations (m/w/d) -->
                                    <!-- <div class="toggle-container question-list">
                                        <div class="panel style1">
                                            <h4 class="panel-title">
                                                <a data-toggle="collapse" href="#tgg2xxxyxz213zzzyy">Assistenz Director Ground Operations (m/w/d)</a>
                                            </h4>
                                            <div id="tgg2xxxyxz213zzzyy" class="panel-collapse collapse">
                                                <div class="panel-content">
                                                    <p><h3>AUFGABEN:</h3></p>
                                                    <ul class="check-circle box">
                                                        <li>Ansprechpartner für die Organisation im Fachbereich Ground Operations </li>
                                                        <li>Verwaltung von Verträgen und Vereinbarungen </li>
                                                        <li>Planung, Koordinierung und Überwachung von Terminen </li>
                                                        <li>Vorbereitung von Anweisungen, Texten und Vorlagen </li>
                                                        <li>Unterstützung bei der Organisation und selbstständige Führung und Anpassung von Projektplänen und Projektdokumentationen </li>
                                                        <li>Erledigung der Korrespondenz des Fachbereichs in den MS-OfficeAnwendungen Word, Excel, PowerPoint und Outlook </li>
                                                        <li>Erstellung von Analysen, Berichten, Präsentationen und Entscheidungsvorlagen </li>
                                                    </ul>

                                                    <p><h3>IHR PROFIL:</h3></p>
                                                    <ul class="check-circle box">
                                                        <li>Erfolgreich abgeschlossene kaufmännische Ausbildung </li>
                                                        <li>Erfahrung im Assistenzbereich, vorzugsweise bei einer Fluggesellschaft </li>
                                                        <li>Fließendes Englisch in Wort und Schrift </li>
                                                        <li>Sehr gute MS-Office Kenntnisse </li>
                                                        <li>Schnelle Auffassungsgabe und Durchsetzungsvermögen </li>
                                                        <li>Stressresistenz, Organisationstalent, Zuverlässigkeit, Flexibilität und Sorgfalt </li>
                                                    </ul>

                                                    <p>Sie erwartet ein herausfordernder Arbeitsplatz mit interessanten Möglichkeiten der persönlichen Weiterentwicklung. Sind Sie interessiert?</p>
                                                    <p>Dann senden Sie bitte Ihre aussagekräftige Bewerbung im PDF-Format unter Angabe Ihrer Gehaltsvorstellungen und des frühesten Eintrittstermins per E-Mail an:</p>
                                                    <p><h2>KARRIERE@SUNDAIR.COM</h2></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div><br /> -->

                                    <!-- Mitarbeiter Ground Operations (m/w/d) -->
                                    <!-- <div class="toggle-container question-list">
                                        <div class="panel style1">
                                            <h4 class="panel-title">
                                                <a data-toggle="collapse" href="#tgg2xxxyxz213">Mitarbeiter Ground Operations (m/w/d)</a>
                                            </h4>
                                            <div id="tgg2xxxyxz213" class="panel-collapse collapse">
                                                <div class="panel-content">
                                                    <p><h3>AUFGABEN:</h3></p>
                                                    <ul class="check-circle box">
                                                        <li>Mitarbeit bei der Umsetzung des Bodenabfertigungskonzeptes des Luftfahrtunternehmens</li>
                                                        <li>Mitwirken bei der Lieferantenauswahl</li>
                                                        <li>Erfassung von Lieferantenangeboten im Bereich Bodenverkehrsdienste</li>
                                                        <li>Stammdateneingabe und –pflege</li>
                                                        <li>Erstellung von Analysen, Berichten, Präsentationen und Entscheidungsvorlagen</li>
                                                        <li>Selbständige Erledigung der Korrespondenz</li>
                                                    </ul>

                                                    <p><h3>IHR PROFIL:</h3></p>
                                                    <ul class="check-circle box">
                                                        <li>Erfolgreich abgeschlossene Ausbildung im Luftverkehr oder der Reisebranche</li>
                                                        <li>Sehr gute MS-Office Kenntnisse</li>
                                                        <li> Sehr gute Deutsch- und Englischkenntnisse in Wort und Schrift; weitere Sprachkenntnisse sind von Vorteil</li>
                                                        <li>Analytisches Denkvermögen, sicheres Zahlenverständnis und ein hohes Maß an Selbstverantwortung</li>
                                                        <li>Schnelle Auffassungsgabe</li>
                                                        <li>Durchsetzungsvermögen</li>
                                                        <li>Stressresistenz, Belastbarkeit, Zuverlässigkeit und Sorgfalt</li>
                                                        <li>Flexibilität sowie Bereitschaft zum Schichtdienst (auch am Wochenende und an Feiertagen)</li>
                                                    </ul>

                                                    <p>Sie erwartet ein herausfordernder Arbeitsplatz mit interessanten Möglichkeiten der persönlichen Weiterentwicklung. Sind Sie interessiert?</p>
                                                    <p>Dann senden Sie bitte Ihre aussagekräftige Bewerbung im PDF-Format unter Angabe Ihrer Gehaltsvorstellungen und des frühesten Eintrittstermins per E-Mail an:</p>
                                                    <p><h2>KARRIERE@SUNDAIR.COM</h2></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div><br /> -->

                                    <!-- ASSISTENT FLUGBETRIEB - CABIN  (m/w/d) – Teilzeit/Vollzeit -->
                                    <!-- <div class="toggle-container question-list">
                                        <div class="panel style1">
                                            <h4 class="panel-title">
                                                <a data-toggle="collapse" href="#tgg2xxxyxz21245678xx">Assistent Flugbetrieb - Cabin (m/w/d)</a>
                                            </h4>
                                            <div id="tgg2xxxyxz21245678xx" class="panel-collapse collapse">
                                                <div class="panel-content">
                                                    <p><h3>AUFGABEN:</h3></p>
                                                    <ul class="check-circle box">
                                                        <li>Ansprechpartner für	die	Organisation im Bereich	Kabine</li>
                                                        <li>Unterstützung	im Bewerber-Management	und	Onboarding für	neue	Flugbegleiter</li>
                                                        <li>Aktualisierung	und	Pflege	der	Cabin	Crew	relevanten	Lizenz-Ablaufdaten</li>
                                                        <li>Verwaltung,	Organisation	und	Verantwortung	der	Uniform	und	Koffer</li>
                                                        <li>Organisatorische	Vor- und	Nachbereitung	sowie	Protokollführung	von	Bewerberveranstaltungen</li>
                                                        <li>Entwicklung	von	Formularen	und	Prozessen für	den	Fachbereich</li>
                                                        <li>Selbständige	Erledigung	der	Korrespondenz	in	den	MS-Office-Anwendungen	Word,	Excel,	PowerPoint	und	Outlook</li>
                                                        <li>Allgemeine	administrative	Aufgaben</li>
                                                    </ul>

                                                    <p><h3>IHR PROFIL:</h3></p>
                                                    <ul class="check-circle box">
                                                        <li>Erfolgreich	abgeschlossene	kaufmännische	Ausbildung</li>
                                                        <li>Erfahrung	in	der	Luftfahrtbrache,	vorzugsweise	bei	einer	kommerziellen	Airline</li>
                                                        <li>Sehr	gute	MS-Office	Kenntnisse</li>
                                                        <li>Sehr	gute	Deutsch	und	Englischkenntnisse</li>
                                                        <li>Schnelle	Auffassungsgabe und	Teamfähigkeit</li>
                                                        <li>Stressresistenz,	Organisationstalent,	Zuverlässigkeit,	Flexibilität und	Sorgfalt</li>
                                                        <li>Grundkenntnisse	im	Arbeitsrecht	sind	von	Vorteil</li>
                                                    </ul>

                                                    <p>Sie	erwartet	ein	herausfordernder	Arbeitsplatz	mit	interessanten	Möglichkeiten	der	persönlichen	Weiterentwicklung.	Sind	Sie	interessiert?</p>
                                                    <p>Dann	senden	Sie	bitte	Ihre	aussagekräftige	Bewerbung	im	PDF-Format	unter	Angabe	Ihrer	Gehaltsvorstellungen	und	des	frühesten	Eintrittstermins	per	E-Mail	an:	</p>
                                                    <p><h2>KARRIERE@SUNDAIR.COM</h2></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div><br /> -->
                                </div>
                                <!-- End:PagePressReleases -->



                                <!-- Begin:Content-SideBar-Booking -->
                                <div class="sidebar col-sm-4 col-md-3">
                                    <sdr-aboutsundair-box></sdr-aboutsundair-box>
                                    <sdr-contact-box></sdr-contact-box>
                                </div>
                                <!-- End:Content-SideBar-Booking -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <<< End:Tabs -->
        </section>


        <!-- Begin:PromoBox -->
        <!-- <sdr-promobox-bremen></sdr-promobox-bremen> -->
        <sdr-promobox-sundair-app></sdr-promobox-sundair-app>
        <!-- End:PromoBox -->
    </div>
</template>

<script>
    import AboutSundairBox from '../shared/sidebar/AboutSundairBox.vue'; // Sidebar (right)
    import ContactBox from '../shared/sidebar/ContactBox.vue'; // Sidebar (right)
    import PromoBoxBremen from '../booking/pagecontent/PromoBoxBremen.vue';
    import PromoBoxSundairApp from '../booking/pagecontent/PromoBoxSundairApp.vue';

    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';
    import { mapActions } from 'vuex';

    export default {

        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-aboutsundair-box': AboutSundairBox,
            'sdr-contact-box': ContactBox,
            'sdr-promobox-bremen': PromoBoxBremen,
            'sdr-promobox-sundair-app': PromoBoxSundairApp,

        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                bannerline1: {
                    en: 'Your opportunity.',
                    de: 'Ihre Gelegenheit.',
                },
                now: {
                    en: 'Now!',
                    de: 'Jetzt!',
                },
                bannerline2: {
                    en: 'Career at your',
                    de: 'Karriere bei Ihrer',
                },
                tabtitle1: {
                    en: 'General',
                    de: 'Allgemein',
                },
                tabtitle2: {
                    en: 'Stralsund Headquarters',
                    de: 'Zentrale Stralsund',
                },
                tabtitle3: {
                    en: 'Branch office Berlin',
                    de: 'Niederlassung Berlin',
                },
                openpositions: {
                    en: 'Open Positions for',
                    de: 'Offene Positionen für',
                }

                // getCurrentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .tab-wrapper {
        background: #F5F5F5;
    }
    .tab-container .tab-content {
        background: #F5F5F5;
    }
    .tab-container.trans-style ul.tabs li a {
        background: #F5F5F5;
    }

    .tab-container.trans-style ul.tabs li.active a {
        color: #9F4378;
    }




    ul.arrow, ul.triangle, ul.circle, ul.check, ul.chevron, ul.arrow-square, ul.check-square, ul.check-circle, ul.decimal, ul.upper-roman, ul.lower-latin, ul.upper-latin {
        font-size: 1.0833em;
    }




    /* >>>  iPAD -------------------------------------------------------------*/
    @media only screen
    and (min-device-width : 768px)
    and (max-device-width : 1024px)  {
        .toggle-container .panel.style1 .panel-content {
            padding: 10px 15px 15px 10px;
        }
    }
</style>